/**
 * EM-2038: Resolve skuID to send for appointment update.
 * Only overrides default '300' with study primary; never discards user's scan-type change.
 * Fetch errors are caught so the appointment update can proceed with fallback (e.g. '300').
 *
 * @param {string} skuID - Current user-selected or context skuID
 * @param {{ primaryFromItems?: string | null, itemsLoaded?: boolean, fetchPrimary?: () => Promise<string | null> }} options
 * @returns {Promise<string>} skuID to send (never throws from fetchPrimary)
 */
export async function resolveSkuIDForAppointmentUpdate(skuID, options = {}) {
  const { primaryFromItems, itemsLoaded, fetchPrimary } = options;
  let skuIDToSend = skuID;

  if (skuIDToSend === '300' && itemsLoaded && primaryFromItems != null) {
    skuIDToSend = primaryFromItems;
  }

  if (skuIDToSend === '300' && typeof fetchPrimary === 'function') {
    try {
      const fetched = await fetchPrimary();
      if (fetched != null) {
        skuIDToSend = fetched;
      }
    } catch {
      // Graceful degradation: keep skuIDToSend as '300' so appointment update still proceeds
    }
  }

  return skuIDToSend;
}
